import { periods, plan_types } from '@public/components/signup_page/plan/plans'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import Plan from '../plan/plan'
import React from 'react'

class Downgrade extends React.Component {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    period: null,
    plan_type: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleSave = this._handleSave.bind(this)

  render() {
    const { period } = this.state
    if(!period) return null
    const sliderClass = 'maha-manage-plan-periods-slider' + (period === 'yearly' ? ' yearly' : '')
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-manage-plan">
          <div className="maha-manage-plan-periods">
            <div className={sliderClass} aria-hidden="true" />
            { periods.map((period,index) => (
              <div { ...this._getPeriod(period) } key={`period_${index}`} style={{ position: 'relative', zIndex: 2 }}>{ period.title }</div>
            )) }
          </div>
          <div className="maha-manage-plan-plans-outer">
            <div className="maha-manage-plan-plans-container">
              <div className="maha-manage-plan-plans">
                <Plan { ...this._getPlan(plan_types[0]) } />
              </div>
            </div>
          </div>
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { props } = this.props
    const { subscription } = props
    this.setState({
      period: subscription.next_period.frequency.units === 'year' ? 'yearly' : 'monthly',
      plan_type: 'essentials'
    })
  }

  _getPanel() {
    return {
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSave }
      ]
    }
  }

  _getPlan(plan_type) {
    const { plans } = this.props.props
    const { period } = this.state
    return {
      is_chosen: plan_type.value === this.state.plan_type,
      period,
      plan_type,
      plan: plans[plan_type.value][period],
      onChoose: this._handlePlanType.bind(this, plan_type.value)
    }
  }

  _getPeriod(period) {
    return {
      className: this._getPeriodClass(period.value),
      onClick: this._handlePeriod.bind(this, period.value)
    }
  }

  _getPeriodClass(value) {
    const { period } = this.state
    const classes = ['maha-manage-plan-period']
    if(period === value) classes.push('selected')
    return classes.join(' ')
  }

  _handleBack() {
    this.props.onBack()
  }

  _handlePeriod(period) {
    this.setState({ period })
  }

  _handlePlanType(plan_type) {
    this.setState({ plan_type })
  }

  _handleSave() {
    const { period, plan_type } = this.state
    const { plans } = this.props.props
    this.props.onSave({
      operation: 'plan',
      plan_id: plans[plan_type][period].id
    })
  }
  
}

export default Downgrade